import { Stack, Card, CardHeader, IconButton, Box } from '@mui/material';
import {
    BoxSpaceBetween,
    CardContentNoPadding
} from '../style/box'

import RefreshIcon from '@mui/icons-material/Refresh';

export default function CommonCard(props) {
    return (
        <Card variant="outlined"
            sx={{
                border: '1px solid rgb(232, 234, 238)',
                boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 1px 0px 0px rgba(0, 0, 0, 0.14), 0px 2px 0px 0px rgba(0, 0, 0, 0.12)'
            }}>
            <Box
                sx={{
                    boxSizing: 'border-box',
                    height: { xs: props.xsHeight, sm: props.height }
                }}
            >
                {props.child}
            </Box>
        </Card>
    )
};
